export default __webpack_public_path__ + "img/ic-virgin.583e53ad.png";